import i18n from '@/i18n'

export default [
    {
        value: i18n.t('groupAcademicFormation.university_fundamental'),
        label: i18n.t('groupAcademicFormation.university_fundamental'),
    },
    {
        value: i18n.t('groupAcademicFormation.university_medium'),
        label: i18n.t('groupAcademicFormation.university_medium'),
    },
    {
        value: i18n.t('groupAcademicFormation.university_higher'),
        label: i18n.t('groupAcademicFormation.university_higher'),
    },
    {
        value: i18n.t('groupAcademicFormation.postgraduate'),
        label: i18n.t('groupAcademicFormation.postgraduate'),
    },
    {
        value: i18n.t('groupAcademicFormation.mba'),
        label: i18n.t('groupAcademicFormation.mba'),
    },
    {
        value: i18n.t('groupAcademicFormation.master'),
        label: i18n.t('groupAcademicFormation.master'),
    },
    {
        value: i18n.t('groupAcademicFormation.doctorate_degree'),
        label: i18n.t('groupAcademicFormation.doctorate_degree'),
    },
]
